//Module for DBL analytics component
angular.module('dbl-analytics', []);